"use strict";
var zip_1 = require('../operator/zip');
exports.zip = zip_1.zipStatic;
//# sourceMappingURL=zip.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/rxjs/observable/zip.js
// module id = ../../../../rxjs/observable/zip.js
// module chunks = 4